import { PriceService } from '@core/services';

export class ItemParams {
  private item_name = '-';
  private item_id = '-';
  private item_brand = '-';
  private item_category = '-';
  private item_category2 = '-';
  private item_category3 = '-';
  private item_category4 = '-';
  private item_category5 = '-';
  private item_variant = '-';
  private currency = '-';
  private price = '-';
  private coupon = '-';
  private discount = '-';
  private quantity = '-';
  private affiliation = '-';
  private index = '-';
  private disney_city = '2359298';
  private universal_city = 'new6280590';
  constructor(
    hotel: any,
    rate: any,
    private priceService: PriceService,
  ) {
    if (hotel !== undefined && rate) {
      if (this.product(hotel.city.id) === 'alojamiento') {
        this.loadAlojamiento(hotel, this.product(hotel.city.id), rate);
      } else {
        this.loadDisneyUNiversal(hotel, this.product(hotel.city.id), rate);
      }

      this.item_id = hotel.id;
      this.currency = (rate.price.currency.code || '').toLocaleLowerCase();
    }
  }

  public loadAlojamiento(hotel, producto, rate) {
    const country = hotel.country ? hotel.country.name : '';
    this.item_name = hotel.city.name;
    this.item_brand = hotel.name;
    this.item_category = `${producto} / ${country} / ${hotel.city.name}`;
    this.price = `${this.priceService.getPrice(rate, 'TOTAL', true)}`;
  }

  public loadDisneyUNiversal(hotel, producto, rate) {
    this.item_name = hotel.name;
    this.item_category = `${producto}`;
    this.item_category5 = hotel.stars;
    this.price = `${this.priceService.getPrice(rate, 'TOTAL', true)}`;
  }

  public getData(producto) {
    let data = {};
    if (producto === 'alojamiento') {
      data = {
        item_name: this.item_name,
        item_id: this.item_id,
        item_brand: this.item_brand,
        item_category: this.item_category,
        item_category2: this.item_category2,
        item_category3: this.item_category3,
        item_category4: this.item_category4,
        item_category5: this.item_category5,
        item_variant: this.item_variant,
        currency: this.currency,
        price: this.price,
        coupon: this.coupon,
        discount: this.discount,
        quantity: this.quantity,
        affiliation: this.affiliation,
        index: this.index,
      };
    } else {
      data = {
        item_name: this.item_name,
        item_id: this.item_id,
        item_category: this.item_category,
        item_category2: this.item_category2,
        item_category3: this.item_category3,
        item_category4: this.item_category4,
        item_category5: this.item_category5,
        item_variant: this.item_variant,
        currency: this.currency,
        price: this.price,
        coupon: this.coupon,
        discount: this.discount,
        quantity: this.quantity,
        affiliation: this.affiliation,
        index: this.index,
      };
    }

    return data;
  }

  private product(idCity) {
    let nameProduct = 'alojamiento';
    switch (idCity) {
      case '2359298': {
        nameProduct = 'disney';
        break;
      }
      case '1326681': {
        nameProduct = 'disney';
        break;
      }
      case this.universal_city: {
        nameProduct = 'universal';
        break;
      }
      default: {
        nameProduct = 'alojamiento';
        break;
      }
    }
    return nameProduct;
  }
}
